import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M12.547 2.487a.75.75 0 0 0-1.141.056c-1.33 1.727-3 4.49-3.5 7.818-.044.292-.078.589-.103.889H3.225a.75.75 0 0 0 0 1.5h4.542c.094 2.755 1.1 5.748 3.664 8.738a.75.75 0 0 0 1.118.023c1.362-1.462 3.189-4.235 3.767-7.64.063-.367.11-.74.142-1.121h4.317a.75.75 0 0 0 0-1.5h-4.284c-.109-2.793-1.185-5.823-3.944-8.763Zm2.442 8.763c-.098-2.224-.9-4.64-2.932-7.057-1.112 1.603-2.283 3.83-2.667 6.39-.033.22-.06.442-.081.667h5.68Zm-5.722 1.5c.087 2.209.84 4.615 2.748 7.082 1.115-1.404 2.381-3.614 2.823-6.212.048-.285.087-.575.114-.87H9.267Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorGlobe;
